import * as ActionTypes from '../action-types'

const vehicleReportGeofences_DefaultState = {
    byGEOID: {},
    recordByStartTime: {},
    allGEOIDs: []
}

export const vehicleReportGeofences = (state = vehicleReportGeofences_DefaultState, action) => {

    let newState = JSON.parse(JSON.stringify(state))

    if(!action) return newState

    switch (action.type) {
        case ActionTypes.GET_VEHICLE_GEOFENCE_REPORTS: {

            const geofenceRecords = action.geofenceRecords
            const geofences = action.geofences

            newState.byGEOID = {}
            newState.recordByStartTime = {}

            geofences && geofences.length && geofences.map(geofence => {

                const geoid = geofence.geoid
                newState.byGEOID[geoid] = geofence

                return null
            })

            geofenceRecords 
            && 
            geofenceRecords.length 
            && 
            geofenceRecords
                .sort((a,b) => b.startTime - a.startTime)
                .map(geofenceRecord => {

                const startTime = geofenceRecord.startTime
                newState.recordByStartTime[startTime] = geofenceRecord

                return null
            })



            // const {
            //     refuels = [],
            //     vid
            //     // thefts = [],
            //     // vLogs = [],
            //     // summary = {}
            // } = report

            // report && report.length && report.map(r => {

            //     const {
            //         refuels = [],
            //         vid 
            //     } = r

            //     newState.reportByVID[vid] = {
            //         refuels,
            //         // thefts
            //     }

            //     if(!newState.allVIDs.includes(vid)) newState.allVIDs.push(vid)

            //     return null
            // })

            // if(vid) {

            //     newState.reportByVID[vid] = {
            //         refuels,
            //         // thefts
            //     }

            //     // newState.logByVID[vid] = vLogs
            //     // newState.summaryByVID[vid] = summary

            //     if(!newState.allVIDs.includes(vid)) newState.allVIDs.push(vid)

            // }

            return newState
        }
        default: {
            return newState;
        }
    }
}